import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext.js";
import StatusContext from "./StatusContext.js";
import ClientContext from "./ClientContext.js";
import axios from "axios"

import { config } from '../config.js';
import { sortChats } from './StatusContext.js';


const CompareAIContext = createContext();

export default CompareAIContext;

export const CompareAIProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [promptsandresponsesPaneOne, setPromptsAndResponsesPaneOne] = useState([]);
    const [promptsandresponsesPaneTwo, setPromptsAndResponsesPaneTwo] = useState([]);
   
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    
    const [confirmDeletePaneOne, setConfirmDeletePaneOne] = useState([])
    const [confirmDeletePaneTwo, setConfirmDeletePaneTwo] = useState([])
  
    
    const [status, setStatus] = useState('');
  
    const [customprompt, setCustomPrompt] = useState({id: 0, default: false, name:'', prompt:''})
    const [showdeletedialog, setShowDeleteDialog] = useState(false)
    const [showsavedialog, setShowSaveDialog] = useState(false)
    const [dialogboxtext, setDialogBoxText] = useState('')
    const [showProgressDialog, setShowProgressDialog] = useState(false)
    
    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
       
        changeLanguage,
        setIsLoading,
        isLoading,
        getChats,
        setShowLoginDialog,
        handleFocus,
      
      
        ScrollResponse,

        setWaitOnResponse,
        responseMode,

        activePane,
        setActivePane,
       
       
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);


    let r = {}

    const getCompareAIProvider = (pane) => {
        let s = 'AIProvider_' + pane
        let aiprovider = localStorage.getItem(s)
       
        if (!aiprovider)
          aiprovider = 'ChatGPT'
       
        return aiprovider
      }

      const getCompareAIModel = (pane) => {
        let s = 'AIModel_' + pane
        let model = localStorage.getItem(s)
       
        if (!model)
          model = 'gpt-5.6-luna'
       
        return model
      }

      const getCompareAIName = (pane) => {
        let s = 'AIName_' + pane
        let name = localStorage.getItem(s)
       
        if (!name)
          name = 'gpt-5.6-luna'
       
        return name
      }

    const getActivePane = () => {
        let pane = localStorage.getItem('activePane')
        console.log("getActivePane:", pane)
       
        if (!pane)
          pane = 1
       
        return pane
      }

    const saveActivePane = (pane) =>{
        
        //console.log("saveActivepane:", pane)
        localStorage.setItem("activePane", pane)
        setActivePane(pane)
    }


   
    const onClearChat = () => {
        setPromptsAndResponsesPaneOne([])
        setPromptsAndResponsesPaneTwo([])
        
        setConfirmDeletePaneOne([])
        setConfirmDeletePaneTwo([])
        
        setChatName('')
        setStatus('')
       
    }

    const deleteChat = async (deletionChat) => {
        console.log("deleteChat")
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }
        let newchatNames = [];
        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/compareai/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }
        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        console.log("Adjusted Chats:", adjustedChats)
        
        var templates = JSON.stringify(adjustedChats)
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/compareai/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }
        setChatNames(adjustedChats);


        setIsLoading(false)

    }

    const displayChat = (displayedChat) => {
        console.log("Display chat:", displayedChat)
        

        onClearChat();

        setTimeout(() => {

        setPromptsAndResponsesPaneOne(displayedChat.promptsandresponses.promptsandresponsesPaneOne)
        setPromptsAndResponsesPaneTwo(displayedChat.promptsandresponses.promptsandresponsesPaneTwo)
       
        setChatName(displayedChat.chatname)

        {
            let deletes = []
            displayedChat.promptsandresponses.promptsandresponsesPaneOne.forEach((item) => {
                let a = {
                    id: item.id,
                    state: false
                }
                deletes.push(a)
            })
            setConfirmDeletePaneOne(deletes)
        }

        {
            let deletes = []
            displayedChat.promptsandresponses.promptsandresponsesPaneTwo.forEach((item) => {
                let a = {
                    id: item.id,
                    state: false
                }
                deletes.push(a)
            })

            setConfirmDeletePaneTwo(deletes)
        }
        
        },0)
    
        
    }

    const onDeletePromptPaneOne = (deletionChat) => {
        if (isLoading)
            return;
        console.log("Compareai: onDeletePromptPaneOne")
     
        let index =0
      
        index = promptsandresponsesPaneOne.indexOf(deletionChat)

        let filteredChats = promptsandresponsesPaneOne.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponsesPaneOne(filteredChats)

        let deleteconfirm = [...confirmDeletePaneOne]

        deleteconfirm.splice(index, 1)
        setConfirmDeletePaneOne(deleteconfirm)
       
    }

    const onDeletePromptPaneTwo = (deletionChat) => {
        if (isLoading)
            return;
        console.log("Compareai: onDeletePromptPaneTwo")
     
        let index =0
      
        index = promptsandresponsesPaneTwo.indexOf(deletionChat)

        let filteredChats = promptsandresponsesPaneTwo.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponsesPaneTwo(filteredChats)

        let deleteconfirm = [...confirmDeletePaneTwo]

        deleteconfirm.splice(index, 1)
        setConfirmDeletePaneTwo(deleteconfirm)
       
    }

    const changeConfirmDeletePaneOne = (prompt, flag) => {
     
        let a = [...confirmDeletePaneOne]
        a.forEach((item) => {
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDeletePaneOne(a)
       
    }

    const changeConfirmDeletePaneTwo = (prompt, flag) => {
     
        let a = [...confirmDeletePaneTwo]
        a.forEach((item) => {
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDeletePaneTwo(a)
       
    }

    const onSave = async () => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return
        }

        let exists = false;

        let newChats = [];
        let newChat = [];
        let newchatNames = [];

        setIsLoading(true);

        let chatstatus = await getChats('compareai');
       
        if (chatstatus.status !== 200)
        {
            setStatusNavbar("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }   
                    
                    let r = {
                        promptsandresponsesPaneOne: [...promptsandresponsesPaneOne],
                        promptsandresponsesPaneTwo: [...promptsandresponsesPaneTwo],
                    }
                    
                    chat.promptsandresponses = r;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0
            newchatNames === 0 ? i = 0 : i = newchatNames.length;

            let r = {
                promptsandresponsesPaneOne: [...promptsandresponsesPaneOne],
                promptsandresponsesPaneTwo: [...promptsandresponsesPaneTwo],
            }
            newChat = {
                id: i,
                chatname: chatName,
                promptsandresponses: r,
            };
            newChats.push(newChat);
            
            console.log("Save chats(before sort):", newChats)
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
            console.log("Save chats(after sort):", newChats)
        }
     
        let templates = JSON.stringify(newChats)
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/compareai/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setIsLoading(false);
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            return
        }

        setChatNames(newChats)
        setIsLoading(false);
       
    }

    const getTopic = async (request) => {

        let server_response = {}
        let result = {
            data: '',
            status: 200,
        }

        if (checkCurrentUser() === false)
            {
                setShowLoginDialog(true)
                result.status = 409;
                return result;
            }
    
        if ( availablecredits === 0 )
            {
                setStatus(changeLanguage('status', 'addcredits'))
                result.status = 409;
                return result;
            }

        if ( responseMode === '3' && availablecredits <= 3000 )
            {
                setStatus(changeLanguage('comprehensiveresponses', 'minimumcredits'))
                result.status = 409;
                return result;
            }

        if (request.length === 0) {
                setStatus(changeLanguage('status', 'promptempty'))
                result.status = 409;
                return result ;
            }


            if (activePane === 1 && promptsandresponsesPaneOne.length > 0)
            {
                    setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
                    handleFocus()
            }

            if (activePane === 2 && promptsandresponsesPaneTwo.length > 0)
            {
                setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
                handleFocus()
            }

        setChatPrompt('')
        setStatus('')

        let req = {
            user:currentUser,
            request: request,
            temperature: temperature,
            aiprovider: getCompareAIProvider(activePane),
            aimodel: getCompareAIModel(activePane),
            ainame: getCompareAIName(activePane),
        }

        /*
        if (activePane === 1)
            setPromptsAndResponsesPaneOne([...promptsandresponsesPaneOne, r])
        else if (activePane === 2)
            setPromptsAndResponsesPaneTwo([...promptsandresponsesPaneTwo, r])
        */
       
        setIsLoading(true)
        try {
          
            let res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          

            server_response = JSON.parse(res.data);
            console.log('getTopics - 4')

            updateCredits(server_response.tokens)
            result.data = server_response.data;

        } catch (err) {

            if (err && err.code) {
                console.log("Error:", err)
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
                result.data = checkServerCode(err.code)
            }
            result.status = 409
         
        }
        setIsLoading(false)
      
        return result
        
    }
  

    const onSubmitChat = async () => {
        console.log('OnSubmitChat:', chatPrompt)

        /*
        if (getCompareAIProvider(activePane) === 'DeepSeek')
            {
                setStatus(changeLanguage('status', 'deepseeknotsupported'))
                return;
            }
         */ 
            if (checkCurrentUser() === false)
            {
                setShowLoginDialog(true)
                return;
            }
    
            if ( availablecredits === 0 )
            {
                setStatus(changeLanguage('status', 'addcredits'))
                return;
            }
    
            if (chatPrompt.length === 0) {
                setStatus(changeLanguage('status', 'promptempty'))
                return;
            }

       
        let temppromptsandresponses = []
        if (activePane === 1)
            temppromptsandresponses = [...promptsandresponsesPaneOne]
        else  if (activePane === 2)
            temppromptsandresponses = [...promptsandresponsesPaneTwo]
        else {
            setStatus('Invalid AI provider.')
            return
        }

        let idx = 0;
        if (temppromptsandresponses.length) {
            idx = temppromptsandresponses[temppromptsandresponses.length - 1].id + 1
        }

        r = {
            id: idx,
            prompt: chatPrompt,
            response: '',
            aiprovider: getCompareAIProvider(activePane),
            aimodel: getCompareAIModel(activePane),
            ainame: getCompareAIName(activePane),
        }

        if (activePane === 1)
        {
            setPromptsAndResponsesPaneOne([...temppromptsandresponses, r])
            if (confirmDeletePaneOne.length <= temppromptsandresponses.length) {
                let a = {
                    id: idx,
                    state: false
                }
                setConfirmDeletePaneOne([...confirmDeletePaneOne, a])
            }
        }
        else if (activePane === 2)
        {
            setPromptsAndResponsesPaneTwo([...temppromptsandresponses, r])
            if (confirmDeletePaneTwo.length <= temppromptsandresponses.length) {
                let a = {
                    id: idx,
                    state: false
                }
                setConfirmDeletePaneTwo([...confirmDeletePaneTwo, a])
            }
        }
        else
            setStatus('Something went wrong. Please try again.')


         let result = await getTopic(chatPrompt)
       

        if (result && result.status !== 200)
            return

        if (!result.data)
            {
                setStatus("Something went wrong. Please try again.")
                return
            }

        let response = result.data

            let i = 0
            if (temppromptsandresponses.length) {
                i = temppromptsandresponses[temppromptsandresponses.length - 1].id + 1
            } else i = 0

            r = {
                id: i,
                prompt: chatPrompt,
                response: response,
                aiprovider: getCompareAIProvider(activePane),
                aimodel: getCompareAIModel(activePane),
                ainame: getCompareAIName(activePane),
            }

            if (responseMode === '1')
            {
             
                if (activePane === 1)
                    {
                        setPromptsAndResponsesPaneOne([...temppromptsandresponses, r])
                        if (confirmDeletePaneOne.length <= temppromptsandresponses.length) {
                            let a = {
                                id: r.id,
                                state: false
                            }
                            setConfirmDeletePaneOne([...confirmDeletePaneOne, a])
                        }
                    }
                    else if (activePane === 2)
                    {
                        setPromptsAndResponsesPaneTwo([...temppromptsandresponses, r])
                        if (confirmDeletePaneTwo.length <= temppromptsandresponses.length) {
                            let a = {
                                id: r.id,
                                state: false
                            }
                            setConfirmDeletePaneTwo([...confirmDeletePaneTwo, a])
                        }
                    }
                  
            
                setWaitOnResponse('')
             
                setIsLoading(false)
                return
            }
   
     
    }


    const onResubmitChat = (prompt) => {
        console.log("onResubmitQuestion:", prompt)
        let text = ''
        SendRequest(prompt.prompt, text, false)
    }

    async function SendRequest(request, task, combinerequestandtask) {
        console.log("CompareAI - SendRequest")
       
        setStatus('')
        if (getCompareAIProvider(activePane) === 'DeepSeek')
        {
            setStatus(changeLanguage('status', 'deepseeknotsupported'))
            return;
        }
      
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        let aiprovider = getCompareAIProvider(activePane)
        let temppromptsandresponses = []

        if (activePane === 1)
            temppromptsandresponses = [...promptsandresponsesPaneOne]
        else  if (activePane === 2)
            temppromptsandresponses = [...promptsandresponsesPaneTwo]
        
        else {
            setStatus('Invalid AI provider.')
            return
        }



        let i = 0;
        if (temppromptsandresponses.length) {
            i = temppromptsandresponses[temppromptsandresponses.length - 1].id + 1
        }

        let r = {
            id: i,
            prompt: request,
            response: "",
            aiprovider: aiprovider,
            aimodel: getCompareAIModel(activePane),
            ainame: getCompareAIName(activePane),
        }

        if (combinerequestandtask)
        {
            r.prompt = task + request
        }

        if (activePane === 1)
        {
            setPromptsAndResponsesPaneOne([...temppromptsandresponses, r])
            if (confirmDeletePaneOne.length <= temppromptsandresponses.length) {
                let a = {
                    id: i,
                    state: false
                }
                setConfirmDeletePaneOne([...confirmDeletePaneOne, a])
            }
        }
        else if (activePane === 2)
        {
            setPromptsAndResponsesPaneTwo([...temppromptsandresponses, r])
            if (confirmDeletePaneTwo.length <= temppromptsandresponses.length) {
                let a = {
                    id: i,
                    state: false
                }
                setConfirmDeletePaneTwo([...confirmDeletePaneTwo, a])
            }
        }
       
        handleFocus()
       
        let rqst = task + request
      
        let req = {
            user:currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: aiprovider,
            aimodel: getCompareAIModel(activePane),
            ainame: getCompareAIName(activePane),
        }

        setIsLoading(true)
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          

            let server_response = JSON.parse(res.data);

            if (temppromptsandresponses.length) {
                i = temppromptsandresponses[temppromptsandresponses.length - 1].id + 1
            } else i = 0
            r = {
                id: i,
                prompt: request,
                response: server_response.data,
                aiprovider: getCompareAIProvider(activePane),
                aimodel: getCompareAIModel(activePane),
                ainame: getCompareAIName(activePane),
            }

            if (combinerequestandtask)
            {
                    r.prompt = task + request
            }

            if (activePane === 1)
                setPromptsAndResponsesPaneOne([...temppromptsandresponses, r])
            else if (activePane === 2)
                setPromptsAndResponsesPaneTwo([...temppromptsandresponses, r])
          
            ScrollResponse()
       
            updateCredits(server_response.tokens)
           

        } catch (err) {
          
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
            if (activePane === 1)
                setPromptsAndResponsesPaneOne(temppromptsandresponses.filter((chat) => { return chat.response !== "" }))
            else if (activePane === 2)
                setPromptsAndResponsesPaneTwo(temppromptsandresponses.filter((chat) => { return chat.response !== "" }))
         
        }
        setIsLoading(false)
    }

    
    

    return <CompareAIContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,

        promptsandresponses,
        setPromptsAndResponses,
       
        promptsandresponsesPaneOne,
        promptsandresponsesPaneTwo,
        
        setPromptsAndResponsesPaneOne,
        setPromptsAndResponsesPaneTwo,
       

        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,
      
        onClearChat,
        onSave,
        deleteChat,
        displayChat,
       
        changeConfirmDeletePaneOne,
        changeConfirmDeletePaneTwo,
        
        confirmDeletePaneOne,
        confirmDeletePaneTwo,

        status,
        setStatus,
    
   
        setCustomPrompt,
        customprompt,
        showdeletedialog, 
        setShowDeleteDialog,
        showsavedialog, 
        setShowSaveDialog,
        setDialogBoxText,
        dialogboxtext,

        onResubmitChat,

        onDeletePromptPaneOne, 
        onDeletePromptPaneTwo, 

        showProgressDialog, 
        setShowProgressDialog,

        activePane,
      

        getActivePane,
        saveActivePane, 

        getCompareAIProvider,
        getCompareAIName,
       
      

    }}>
        {props.children}
    </CompareAIContext.Provider>
})